import { Link, NavLink } from "react-router-dom";

export const SiteHeader = () => (
  <header className="inner-header" data-testid="inner-page-header">
    <div className="inner-header-shell">
      <Link className="inner-brand" to="/" aria-label="Explordio home" data-testid="inner-header-home-link">
        <img src="/assets/brand/explordio-logo-say-it.png" alt="Explordio" data-testid="inner-header-logo" />
      </Link>
      <nav className="inner-nav" aria-label="Site navigation" data-testid="inner-page-navigation">
        <NavLink to="/privacy" data-testid="header-privacy-link">Privacy</NavLink>
        <NavLink to="/terms" data-testid="header-terms-link">Terms</NavLink>
        <NavLink to="/contact" data-testid="header-contact-link">Contact</NavLink>
      </nav>
    </div>
  </header>
);